<template>
  <a-modal
    v-model="showModal"
    :footer="null"
    :closable="false"
    :centered="true"
    :class="`${currentStep ? '' : 'infoModal'} modalContainer tutorialModal`"
    @cancel="null"
  >
    <div v-if="!currentStep" class="p-4 text-center">
      <img
        class="rounded-circle mb-3"
        src="../../../assets/icons/tutorial.png"
        alt="tutorial"
      />
      <h4 class="gray700 mb-3 fw700">Let’s show you around</h4>
      <p class="gray500 mb-4">
        Ready to explore everything you need to know? Just go through the steps.
        It only takes a minute.
      </p>
      <button
        class="rounded w-100 btn btn-one hide-in-mobile"
        @click="handleOk"
        :style="{ background: getPrimaryColor() }"
      >
        Show me around
      </button>
      <button
        class="rounded w-100 btn btn-one show-in-mobile"
        @click="handleOkMobile"
        :style="{ background: getPrimaryColor() }"
      >
        Show me around
      </button>
      <button class="rounded w-100 btn btn-two" @click="handleCancel">
        I want to explore myself
      </button>
    </div>
    <div v-else class="p-4" :style="{ 'background-color': getSecondaryColor(), 'text-align': 'initial' }">
      <h4 class="fw700 my-0 font-white font24">{{ steps[currentStep].title }}</h4>
      <p class="mt-3 mb-4 font-white font16">{{ steps[currentStep].description }}</p>
      <div class="ml-3">
        <span class="font12 fw700 font-white"> {{ currentStep }}/{{ steps.length - 1 }} </span>
        <button v-if="currentStep > 1" @click="currentStep--" class="py-2 px-3 rounded ml-4 font12 fw700 cp gray600 bg-gray200" :style="{ border: 'none' }">Back</button>
        <button
          v-if="currentStep < steps.length - 1"
          @click="currentStep++"
          class="py-2 px-3 rounded ml-4 font12 fw700 cp font-white"
          :style="{ 'background-color': getPrimaryColor(), border: 'none' }"
        >
          Next
        </button>
        <button class="py-2 px-3 rounded ml-4 font12 fw700 cp font-white" :style="{ 'background-color': getPrimaryColor(), border: 'none' }" v-else @click="handleCancel">Done</button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("user");

export default {
  data() {
    return {
      showModal: false,
      currentStep: 0,
      steps: [
        { title: "", description: "" },
        {
          title: "Update your profile",
          description:
            "Updating your profile with relevant information about yourself and your specific condition, including symptoms and treatments, will help others connect and interact with you better.",
        },
        {
          title: "Update Your DoveDaily",
          description:
            "DoveDaily is a feature that you can sync with any health & fitness App you are using. It can also help you keep track of your moods, treatment goals, and progress, including medication effectiveness.",
        },
        {
          title: "Connect with other people",
          description:
            "Adding people to your circles can help you relate better with others, share your personal experiences, and connect meaningfully with a community that supports those with chronic conditions.",
        },
        {
          title: "Create your circle",
          description:
            "You can create your own circles based on similarities such as condition subtype, treatment regimen, or activity participation. You may also create circles based on your geographical region.",
        },
        {
          title: "Review providers or medical institutions",
          description:
            "You may rate and review healthcare providers and institutions based on your experiences and interactions with them, which can help them address any concerns that you may be having.",
        },
      ],
    };
  },
  created() {
    if (!this.authUser.user.tutorial_seen) {
      this.show();
    }
    if (
      this.authUser.user.role !== "patient" &&
      this.authUser.user.role !== "caregiver"
    ) {
      this.steps.splice(2, 1);
    }
  },
  methods: {
    show() {
      this.$store.commit("User/setTutorialStep", false);
      this.showModal = true;
    },
    handleOk() {
      this.$store.commit("User/setTutorialStep", true);
      this.showModal = false;
    },
    handleOkMobile() {
      this.currentStep = 1;
    },
    handleCancel() {
      setTimeout(() => {
        this.currentStep = 0
      }, 1000)
      this.showModal = false;
      UserRepository.editUserDetails(
        this.authUser.user.id,
        this.currentCircle.id,
        this.authUser.user.role,
        { tutorial_seen: true }
      )
        .then((res) => {
          // this.$notification.success({ message: "Done", description: "Tutorial won't be shown anymore." })
          this.authUser.user.tutorial_seen = true;
        })
        .catch((e) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-modal-content,
.modalContainer {
  width: 400px !important;
}
.btn {
  padding: 12px 24px;
  margin-top: 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.btn-one {
  color: #ffffff !important;
}
.btn-two {
  background: #e2e8f0;
  color: #47556e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/activity/Tutorial.vue